<template>
  <div class="card chart-card">
      <div class="card-header" v-if="$slots.header">
        <slot name="header"></slot>
      </div>
      <div class="card-body">
          <div class="card-box">
            <chartjs-bar
              :chartData="chartData"
              :chartOptions="chartOptions"><!--style="width:80%;display:block;margin-left:auto;margin-right:auto"-->
            </chartjs-bar>
          </div>
      </div>
      <div class="card-footer" v-if="$slots.footer">
        <slot name="footer"></slot>
      </div>
  </div>
</template>
<script>
  import Card from '../Card.vue'
  import ChartjsBar from '../../Chartjs/ChartjsBar.vue'
  import util from 'util'

  export default {
      name: 'chartjs-bar-card',
      components: {
          Card,
          ChartjsBar
      },
      props: {
          chartData: {
              type: Object,
              default: () => {
                  return {}
              }
          },
          chartOptions: {
              type: Object,
              default: () => {
                  return {}
              }
          }
      }
  }
</script>
<style>
</style>
